import { rutinInfos } from './RutinInfo';
import notImplemented from '../Components/notImplemented/notImplemented';
import { withAddStartedRoutine } from '../../../StartPanel/Components/Cards/StartedRoutines/startedRoutineQueries';
import { createListRutin } from '../Components/ListRutin/ListRutin';
import { IRoutine, ShowDetailsRight } from './Delsystem';
import { initConst } from '../../../../Utils/utils';
import getStandardRutin from '../Utils/getStandardRutin';

export const styrvarden: () => { [rtnKey: string]: IRoutine } = initConst(
  () => ({
    ////////////////////////////////////
    // Gemensamma
    ////////////////////////////////////
    rtnEnhet: {
      component: getStandardRutin(rutinInfos.rtnEnhet, 'LAEnhet'),
    },
    rtnFakturalayout: {
      component: getStandardRutin(
        rutinInfos.rtnFakturalayout,
        'SYSFakturalayout'
      ),
    },
    rtnRapportLayout: {
      component: withAddStartedRoutine(rutinInfos.rtnRapportLayout)(
        createListRutin(
          'SYSFakturalayout',
          [
            { attributeDef: 'BENAMNING', caption: 'Namn' },
            { attributeDef: 'UTSKRIFTSTYP', caption: 'Utskriftstyp' },
          ],
          notImplemented('Brevlayout DetailComp')
        )
      ),
    },
    rtnValuta: {
      component: getStandardRutin(rutinInfos.rtnValuta, 'SYSValuta'),
    },
    rtnBank: {
      component: getStandardRutin(rutinInfos.rtnBank, 'SYSBank'),
    },
    rtnRanteTabell: {
      component: getStandardRutin(rutinInfos.rtnRanteTabell, 'SYSRanteTabell'),
    },
    rtnKundkategori: {
      component: getStandardRutin(rutinInfos.rtnKundkategori, 'KRKundkategori'),
    },
    rtnHuvudRubrik: {
      component: getStandardRutin(rutinInfos.rtnHuvudRubrik, 'ARHuvudRubrik'),
    },
    rtnRubrik: {
      component: getStandardRutin(rutinInfos.rtnRubrik, 'ARRubrik'),
    },
    rtnAnlGrupp: {
      component: getStandardRutin(rutinInfos.rtnAnlGrupp, 'ARAnlGrupp'),
    },
    rtnOmrade: {
      component: getStandardRutin(rutinInfos.rtnOmrade, 'ARPlats'),
    },
    rtnAnlKat: {
      component: getStandardRutin(rutinInfos.rtnAnlKat, 'ARAnlKat'),
    },
    rtnVerksamhetskod: {
      component: getStandardRutin(
        rutinInfos.rtnVerksamhetskod,
        'ARVerksamhetskod'
      ),
    },
    rtnAtgardskod: {
      component: getStandardRutin(rutinInfos.rtnAtgardskod, 'ARAtgardskod'),
    },
    rtnKomponent: {
      component: getStandardRutin(rutinInfos.rtnKomponent, 'ARKomponent'),
    },
    rtnInventeringsansvarig: {
      component: getStandardRutin(
        rutinInfos.rtnInventeringsansvarig,
        'SYSUser'
      ),
    },
    rtnFordelningsmall: {
      component: getStandardRutin(
        rutinInfos.rtnFordelningsmall,
        'EKAutomatkonteringar'
      ),
    },
    ////////////////////////////////////
    // BO
    ////////////////////////////////////
    rtnAktTypInstallningar: {
      component: getStandardRutin(
        rutinInfos.rtnAktTypInstallningar,
        'BOAktivitetstyp'
      ),
    },
    rtnUsersBO: {
      component: getStandardRutin(rutinInfos.rtnUsersBO, 'SYSUser'),
    },
    rtnBegravningstyp: {
      component: getStandardRutin(
        rutinInfos.rtnBegravningstyp,
        'BOBegravningstyp'
      ),
    },
    rtnBokningsgrupper: {
      component: getStandardRutin(
        rutinInfos.rtnBokningsgrupper,
        'SYSBokngrupp'
      ),
    },
    rtnVerksamhetstyper: {
      component: getStandardRutin(
        rutinInfos.rtnVerksamhetstyper,
        'BOVerksamhetstyper'
      ),
    },
    rtnGudstjansttyp: {
      component: getStandardRutin(
        rutinInfos.rtnGudstjansttyp,
        'BOGudstjansttyp'
      ),
    },
    rtnAktivitetskategori: {
      component: getStandardRutin(
        rutinInfos.rtnAktivitetskategori,
        'BOKategori'
      ),
    },
    rtnResurstyper: {
      component: notImplemented('Resurstyper'),
    },
    rtnPlaneringskategorier: {
      component: getStandardRutin(
        rutinInfos.rtnPlaneringskategorier,
        'BOPlaneringskategori'
      ),
    },
    rtnResursgrupp: {
      component: getStandardRutin(rutinInfos.rtnResursgrupp, 'BOResursgrupp'),
    },
    ////////////////////////////////////
    // DI
    ////////////////////////////////////
    rtnDiariePlan: {
      component: getStandardRutin(rutinInfos.rtnDiariePlan, 'DIDiarieplan'),
    },
    rtnMottagare: {
      component: getStandardRutin(rutinInfos.rtnMottagare, 'DIAvsMot'),
    },
    rtnHandlaggare: {
      component: getStandardRutin(rutinInfos.rtnHandlaggare, 'DIHandlaggare'),
    },
    rtnHandlingstyp: {
      component: getStandardRutin(rutinInfos.rtnHandlingstyp, 'DIHandlingstyp'),
    },
    rtnDIStandardText: {
      component: getStandardRutin(
        rutinInfos.rtnDIStandardText,
        'SYSStandardtext'
      ),
    },
    rtnDIStandardTextArkiv: {
      component: getStandardRutin(
        rutinInfos.rtnDIStandardTextArkiv,
        'SYSStandardtext'
      ),
    },
    rtnDiariegrupp: {
      component: getStandardRutin(rutinInfos.rtnDiariegrupp, 'SYSDiariegrupp'),
    },
    rtnUsersDI: {
      component: getStandardRutin(rutinInfos.rtnUsersDI, 'SYSUser'),
    },
    //     { attributeDef: 'ANTAL_BESOKARE', caption: 'Antal' },
    ////////////////////////////////////
    // EK
    ////////////////////////////////////
    rtnBokfar: {
      component: getStandardRutin(rutinInfos.rtnBokfar, 'SYSBokfar'),
    },
    rtnUsersEK: {
      component: getStandardRutin(rutinInfos.rtnUsersEK, 'SYSUser'),
    },
    rtnKodbehorigheter: {
      component: getStandardRutin(
        rutinInfos.rtnKodbehorigheter,
        'EKAnvKontobegr'
      ),
    },
    rtnTillaggsinfo: {
      component: getStandardRutin(rutinInfos.rtnTillaggsinfo, 'EKTillaggsinfo'),
    },
    optMomskod: {
      component: getStandardRutin(rutinInfos.optMomskod, 'EKMomskod'),
    },
    rtnMoms: {
      component: getStandardRutin(rutinInfos.rtnMoms, 'SYSMoms'),
      defaultShowDetailsRight: ShowDetailsRight.Disabled,
    },
    rtnKonteringskod: {
      component: getStandardRutin(
        rutinInfos.rtnKonteringskod,
        'SYSKonteringskod'
      ),
    },
    rtnDetaljeringsniva: {
      component: getStandardRutin(
        rutinInfos.rtnDetaljeringsniva,
        'EKDetaljeringsniva'
      ),
    },
    rtnSIEMottagningsvag: {
      component: getStandardRutin(
        rutinInfos.rtnSIEMottagningsvag,
        'SYSSIEMottagningsvag'
      ),
    },
    rtnSprak: {
      component: getStandardRutin(rutinInfos.rtnSprak, 'SYSSprak'),
    },
    rtnLand: {
      component: getStandardRutin(rutinInfos.rtnLand, 'SYSLand'),
    },
    rtnBokforingsmall: {
      component: getStandardRutin(
        rutinInfos.rtnBokforingsmall,
        'EKBokforingsmall'
      ),
    },
    rtnGavogrupp: {
      component: getStandardRutin(rutinInfos.rtnGavogrupp, 'EKGavoGrupp'),
    },
    rtnGavorubrik: {
      component: getStandardRutin(rutinInfos.rtnGavorubrik, 'EKGavorubrik'),
    },
    rtnBudgetgrupp: {
      component: getStandardRutin(rutinInfos.rtnBudgetgrupp, 'EKBudgetgrupp'),
    },
    rtnBudgetkategori: {
      component: getStandardRutin(
        rutinInfos.rtnBudgetkategori,
        'EKBudgetkategori'
      ),
    },
    rtnLonetillagg: {
      component: getStandardRutin(rutinInfos.rtnLonetillagg, 'EKLonetillagg'),
    },
    rtnBefattningskod: {
      component: getStandardRutin(
        rutinInfos.rtnBefattningskod,
        'EKBefattningskod'
      ),
    },
    rtnAvtalsomrade: {
      component: getStandardRutin(rutinInfos.rtnAvtalsomrade, 'EKAvtalsOmrade'),
    },
    rtnEKLoneart: {
      component: getStandardRutin(rutinInfos.rtnEKLoneart, 'EKLoneart'),
    },
    ////////////////////////////////////
    // GA
    ////////////////////////////////////
    optGravlistor: {
      component: getStandardRutin(rutinInfos.optGravlistor, 'GAGravList'),
    },
    ////////////////////////////////////
    // KJ
    ////////////////////////////////////
    optKrematorie: {
      component: getStandardRutin(rutinInfos.optKrematorie, 'KJKrematorium'),
    },
    optKremRapportLayout: {
      component: getStandardRutin(
        rutinInfos.optKremRapportLayout,
        'KJRapportlayout'
      ),
    },
    optKremlistor: {
      component: getStandardRutin(rutinInfos.optKremlistor, 'KJKremList'),
    },
    ////////////////////////////////////
    // KR
    ////////////////////////////////////
    optMallKund: {
      component: withAddStartedRoutine(rutinInfos.optMallKund)(
        createListRutin(
          'KRKund',
          [
            { attributeDef: 'KUNDNR_KONTONR', caption: '' },
            { attributeDef: 'OrgPers.Namn', caption: 'Namn' },
            {
              attributeDef: 'OrgPers.Adress.KompaktAdressRad',
              caption: 'Adress',
            },
            {
              attributeDef: 'ReskontraSaldoAktInt',
              caption: 'Saldo reskontra',
            },
            { attributeDef: 'Kundtyp', caption: '' },
            { attributeDef: 'KundkategoriKodBen', caption: '' },
          ],
          notImplemented('Mallkunder DetailComp')
        )
      ),
    },
    rtnFakturaformedlare: {
      component: getStandardRutin(
        rutinInfos.rtnFakturaformedlare,
        'SYSFakturaformedlare'
      ),
    },
    rtnBetalningssatt: {
      component: getStandardRutin(
        rutinInfos.rtnBetalningssatt,
        'SYSBetalningssatt'
      ),
    },
    rtnInbetalningsvag: {
      component: getStandardRutin(
        rutinInfos.rtnInbetalningsvag,
        'KRInbetalningsvag'
      ),
    },
    rtnBetalningsvillkor: {
      component: getStandardRutin(
        rutinInfos.rtnBetalningsvillkor,
        'SYSBetalningsvillkor'
      ),
    },
    rtnAutogiromall: {
      component: getStandardRutin(
        rutinInfos.rtnAutogiromall,
        'SYSAutogiroMall'
      ),
    },
    rtnKravrutin: {
      component: getStandardRutin(rutinInfos.rtnKravrutin, 'SYSKravrutin'),
    },

    ////////////////////////////////////
    // LR
    ////////////////////////////////////
    rtnLevkategori: {
      component: getStandardRutin(rutinInfos.rtnLevkategori, 'LRLeverantorkat'),
    },
    rtnAttestGrupp: {
      component: getStandardRutin(rutinInfos.rtnAttestGrupp, 'LRAttestGrupp'),
    },
    rtnAttestOmrade: {
      component: getStandardRutin(rutinInfos.rtnAttestOmrade, 'LRAttestOmrade'),
    },
    rtnUtbetalningsvag: {
      component: getStandardRutin(
        rutinInfos.rtnUtbetalningsvag,
        'SYSUtbetalningsvag'
      ),
    },
    rtnFakturamottagningsvag: {
      component: getStandardRutin(
        rutinInfos.rtnFakturamottagningsvag,
        'LRFakturamottagningsvag'
      ),
    },
    rtnFakturakoder: {
      component: getStandardRutin(rutinInfos.rtnFakturakoder, 'SYSFakturakod'),
    },
    rtnFakturaradskoder: {
      component: getStandardRutin(
        rutinInfos.rtnFakturaradskoder,
        'SYSFakturaradskod'
      ),
    },
    rtnAttestforslag: {
      component: getStandardRutin(
        rutinInfos.rtnAttestforslag,
        'LRAttestforslag'
      ),
    },
    rtnClearingArtiklar: {
      component: getStandardRutin(
        rutinInfos.rtnClearingArtiklar,
        'SYSKOBArtikel'
      ),
    },

    ////////////////////////////////////
    // MU
    ////////////////////////////////////

    ////////////////////////////////////
    // OF
    ////////////////////////////////////
    rtnOrdermottagningsvag: {
      component: getStandardRutin(
        rutinInfos.rtnOrdermottagningsvag,
        'SYSOrdermottagningsvag'
      ),
    },

    ////////////////////////////////////
    // PU
    ////////////////////////////////////

    ////////////////////////////////////
    // SYS
    ////////////////////////////////////
    ////////////////////////////////////
    // TI
    ////////////////////////////////////
    rtnTidGrupp: {
      component: getStandardRutin(rutinInfos.rtnTidGrupp, 'TITidGrupp'),
    },
    rtnTIInstallningar: {
      component: getStandardRutin(
        rutinInfos.rtnTIInstallningar,
        'TIInstallningar'
      ),
    },
    rtnVeckoschema: {
      component: getStandardRutin(rutinInfos.rtnVeckoschema, 'TIVeckoschema'),
    },
    rtnDagschema: {
      component: getStandardRutin(rutinInfos.rtnDagschema, 'TIDagSchema'),
    },
    rtnSchemaOB: {
      component: getStandardRutin(rutinInfos.rtnSchemaOB, 'TIOBTid'),
    },
    rtnTidbank: {
      component: getStandardRutin(rutinInfos.rtnTidbank, 'TITidbank'),
    },
    rtnLoneartKategori: {
      component: getStandardRutin(
        rutinInfos.rtnLoneartKategori,
        'TILoneartKategori'
      ),
    },
    rtnRapporteringskod: {
      component: getStandardRutin(
        rutinInfos.rtnRapporteringskod,
        'TIRapporteringskod'
      ),
    },
    rtnRapporteringskod2: {
      component: getStandardRutin(
        rutinInfos.rtnRapporteringskod2,
        'TIRapporteringskod2'
      ),
    },
    rtnAnstalldKategori: {
      component: getStandardRutin(
        rutinInfos.rtnAnstalldKategori,
        'TIAnstalldKategori'
      ),
    },
    rtnFaktureringstyp: {
      component: getStandardRutin(
        rutinInfos.rtnFaktureringstyp,
        'TIFaktureringstyp'
      ),
    },
    rtnPrioritet: {
      component: getStandardRutin(rutinInfos.rtnPrioritet, 'TIPrioritet'),
    },
    rtnTIAttestomraden: {
      component: getStandardRutin(
        rutinInfos.rtnTIAttestomraden,
        'TIAttestomrade'
      ),
    },
    rtnTIAttestkategorier: {
      component: getStandardRutin(
        rutinInfos.rtnTIAttestkategorier,
        'TIAttestkategori'
      ),
    },
    rtnLonearter: {
      component: getStandardRutin(rutinInfos.rtnLonearter, 'TILoneart'),
    },
    rtnOrderOmg: {
      component: getStandardRutin(rutinInfos.rtnOrderOmg, 'GAOrderOmg'),
    },
    rtnPubliceraGravsatta: {
      component: notImplemented('Publicera till Svenska Gravar'),
    },
    rtnInformationskiosk: {
      component: getStandardRutin(
        rutinInfos.rtnInformationskiosk,
        'GAInfokiosk'
      ),
    },
  })
);
